// 表单验证工具

// 手机号验证
export const validatePhone = (phone) => {
  const phoneRegex = /^1[3-9]\d{9}$/;
  if (!phone) {
    return '手机号不能为空';
  }
  if (!phoneRegex.test(phone)) {
    return '请输入有效的手机号';
  }
  return '';
};

// 密码验证
export const validatePassword = (password) => {
  if (!password) {
    return '密码不能为空';
  }
  if (password.length < 6) {
    return '密码长度不能少于6位';
  }
  if (password.length > 20) {
    return '密码长度不能超过20位';
  }
  return '';
};

// 验证码验证
export const validateVerifyCode = (code) => {
  const codeRegex = /^\d{6}$/;
  if (!code) {
    return '验证码不能为空';
  }
  if (!codeRegex.test(code)) {
    return '验证码必须是6位数字';
  }
  return '';
};

// 邮箱验证
export const validateEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!email) {
    return '邮箱不能为空';
  }
  if (!emailRegex.test(email)) {
    return '请输入有效的邮箱地址';
  }
  return '';
};

// 用户名验证
export const validateUsername = (username) => {
  if (!username) {
    return '用户名不能为空';
  }
  if (username.length < 2) {
    return '用户名长度不能少于2位';
  }
  if (username.length > 20) {
    return '用户名长度不能超过20位';
  }
  return '';
};

// 表单整体验证
export const validateForm = (formData, rules) => {
  const errors = {};
  
  Object.keys(rules).forEach(field => {
    const value = formData[field];
    const rule = rules[field];
    
    if (rule.required && !value) {
      errors[field] = rule.message || `${field}不能为空`;
      return;
    }
    
    if (rule.pattern && value && !rule.pattern.test(value)) {
      errors[field] = rule.message || `${field}格式不正确`;
      return;
    }
    
    if (rule.minLength && value && value.length < rule.minLength) {
      errors[field] = rule.message || `${field}长度不能少于${rule.minLength}位`;
      return;
    }
    
    if (rule.maxLength && value && value.length > rule.maxLength) {
      errors[field] = rule.message || `${field}长度不能超过${rule.maxLength}位`;
      return;
    }
    
    if (rule.custom && value) {
      const customError = rule.custom(value);
      if (customError) {
        errors[field] = customError;
      }
    }
  });
  
  return errors;
};

// 登录表单验证规则
export const loginRules = {
  account: {
    required: true,
    message: '账号不能为空'
  },
  psw: {
    required: true,
    message: '密码不能为空'
  }
};

// 注册表单验证规则
export const registerRules = {
  phone: {
    required: true,
    pattern: /^1[3-9]\d{9}$/,
    message: '请输入有效的手机号'
  },
  verifyCode: {
    required: true,
    pattern: /^\d{6}$/,
    message: '验证码必须是6位数字'
  },
  psw: {
    required: true,
    minLength: 6,
    maxLength: 20,
    message: '密码长度6-20位'
  },
  confirmPsw: {
    required: true,
    message: '请确认密码'
  }
};

// 忘记密码表单验证规则
export const forgotPasswordRules = {
  phone: {
    required: true,
    pattern: /^1[3-9]\d{9}$/,
    message: '请输入有效的手机号'
  },
  verifyCode: {
    required: true,
    pattern: /^\d{6}$/,
    message: '验证码必须是6位数字'
  },
  psw: {
    required: true,
    minLength: 6,
    maxLength: 20,
    message: '新密码长度6-20位'
  },
  confirmPsw: {
    required: true,
    message: '请确认新密码'
  }
};